/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { ApiErrorService } from '../api-error.service';
import { HelperService } from '../helper/helper.service';
import { TxService } from '../shared/tx.service';
import { SmartHttpService } from '../smart-http/smart-http.service';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';

@Injectable({
  providedIn: 'root',
})
export class AutoCheckoutService {
  // https://devapi.travelx.ai/api/autocheckoutform?deviceid=9fee70e2d5b2e6a5&session_id=1587711453595&page=1&version=2&count=10&key=bcqvmn2gabuu&pid=trxa&uuid=18f2f566-46b3-4001-9aa9-591fa812d97a&lang=en&currency=INR&s_id=1587711453595&platformid=9fee70e2d5b2e6a5&utm_source=&utm_campaign=&utm_medium=&dpi=480&userid=&platform=android&ignorepastflight=1&storeid=4012&userid=1

  apiParams: any;

  constructor(
    private httpClient: SmartHttpService,
    private helperService: HelperService,
    private envService: TxService,
    private apiErrorService: ApiErrorService,
    private localStorageData: LocalStorageService
  ) {
    this.initApiParams();
  }

  public get autoCheckoutApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.autoCheckoutApi = `${this.envService.autoCheckoutFormApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public set autoCheckoutApi(value: string) {}

  initApiParams() {
    this.apiParams = {};
  }

  getAutoCheckoutForm(storeId, forceStoreId = false) {
    this.apiParams.storeid = forceStoreId
      ? storeId
      : this.localStorageData.getItem(localStorageKeys.TEMP_STORE_ID) || storeId;
    return this.httpClient.getWithErorrHandler<any>(this.autoCheckoutApi);
  }
}
